import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Row } from 'react-styled-flexboxgrid';
import { FormItemV3 } from './FormItemV3';

var FormRowV3 = function FormRowV3(props) {
  return /*#__PURE__*/React.createElement(Row, null, props.row.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FormItemV3, _extends({
      key: index
    }, props, item));
  }));
};

export { FormRowV3 };